import { render, staticRenderFns } from "./AlsokPanel.vue?vue&type=template&id=5f51190c&scoped=true"
import script from "./AlsokPanel.vue.js?vue&type=script&lang=js&external"
export * from "./AlsokPanel.vue.js?vue&type=script&lang=js&external"
import style0 from "./AlsokPanel.vue?vue&type=style&index=0&id=5f51190c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f51190c",
  null
  
)

export default component.exports